import React from "react";
import PropTypes from "prop-types";


export default function SmartGuideLine({
  guide,
}) {
  const style =
    guide.orientation === "vertical"
      ? {
          left: `${guide.position}px`,
          top: `${guide.start}px`,
          height: `${Math.max(
            0,
            guide.end - guide.start,
          )}px`,
        }
      : {
          top: `${guide.position}px`,
          left: `${guide.start}px`,
          width: `${Math.max(
            0,
            guide.end - guide.start,
          )}px`,
        };

  return (
    <div
      className={[
        "studio-smart-guide",
        `studio-smart-guide--${guide.orientation}`,
      ].join(" ")}
      data-smart-guide-id={guide.id}
      data-smart-guide-orientation={guide.orientation}
      style={style}
      aria-hidden="true"
    />
  );
}


SmartGuideLine.propTypes = {
  guide: PropTypes.shape({
    id: PropTypes.string.isRequired,
    orientation: PropTypes.oneOf([
      "horizontal",
      "vertical",
    ]).isRequired,
    position: PropTypes.number.isRequired,
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired,
  }).isRequired,
};
